import { render } from "./InjectPoint.vue?vue&type=template&id=cde272d2&scoped=true"
import script from "./InjectPoint.vue?vue&type=script&lang=js"
export * from "./InjectPoint.vue?vue&type=script&lang=js"

import "./InjectPoint.vue?vue&type=style&index=0&id=cde272d2&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cde272d2"]])

export default __exports__